import React from 'react'
import { Helmet as ReactHelmet } from 'react-helmet'

const Helmet = ({ description, keywords, title }) => <ReactHelmet>
  <title>{title}</title>
  <meta name={'description'} content={description} />
  <meta name={'keywords'} content={keywords} />
</ReactHelmet>

export default Helmet



// WEBPACK FOOTER //
// ./src/components/seo/Helmet.js